// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderLogo-module__container--ohpFs{width:11.278rem}.HeaderLogo-module__image--DyhKu{width:100%;height:auto;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HeaderLogo-module__container--ohpFs`,
	"image": `HeaderLogo-module__image--DyhKu`
};
export default ___CSS_LOADER_EXPORT___;
